var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.5H9.5V2.5H2.5V1.5ZM2.5 9.5H1.5V2.5H2.5V9.5ZM9.5 9.5V10.5H2.5V9.5H9.5ZM9.5 9.5H10.5V2.5H9.5V9.5ZM5 4H4V5H5V4ZM7 4H8V5H7V4ZM4.5 8V7H7.5V8H8.5V7H7.5V6H4.5V7H3.5V8H4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaS);
export default __webpack_public_path__ + "static/media/sa-s.462390a356ae370838249a31cc0b745d.svg";
export { ForwardRef as ReactComponent };